import React from 'react';
import { OptionalFieldsProps } from '../../Objects/interfaces/AppInterface';
import FormInput from '../Ui/FormInput';
import { ENV_TEACHR, isBrandActive } from '../../config/environment.config';

const OptionalFields: React.FC<OptionalFieldsProps> = ({
  firstName,
  setFirstName,
  lastName,
  setLastName,
}) => (
  <div className="grid md:grid-cols-1 gap-4">
    <FormInput
      label={isBrandActive(ENV_TEACHR) ? "Prénom de l'élève" : "Prénom du client"}
      type="text"
      placeholder="Ex: John"
      value={firstName}
      onChange={(e) => setFirstName(e.target.value)}
    />
    <FormInput
      label="Nom de famille"
      type="text"
      placeholder="Ex: DUPONT"
      value={lastName}
      onChange={(e) => setLastName(e.target.value)}
    />
  </div>
);

export default OptionalFields;